/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs */

const en__field__enum_teachingsubjectinterest_subject_philosophy19 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophy`)
};

const de__field__enum_teachingsubjectinterest_subject_philosophy19 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie`)
};

/**
* | output |
* | --- |
* | "Philosophy" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_philosophy19 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Philosophy19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_philosophy19(inputs)
	return de__field__enum_teachingsubjectinterest_subject_philosophy19(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_philosophy19 as "_field__enum_teachingSubjectInterest_SUBJECT_PHILOSOPHY" }